export default __webpack_public_path__ + "static/comfort-relief-62e8aa0761fa3741a5f27a4bdbb5c1e7.png";